import type { FC } from "react";

import { DialogProfileSearchForm } from "src/app/features/DialogProfile/components/forms/DialogProfileSearchForm";
import { DialogProfilesTable } from "src/app/features/DialogProfile/components/tables/DialogProfilesTable";
import type { DialogProfileEntity } from "src/app/features/DialogProfile/types/DialogProfileEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const DialogProfilesPage: FC<NoneOwnProps> = () => {
    const table = <DialogProfilesTable />;
    const searchForm = <DialogProfileSearchForm />;

    return (
        <PageLayout name="dialogProfiles_page">
            <PageTitle translationKey="menu.dialogProfiles" />
            <ResourceManager<DialogProfileEntity>
                useDataGroup
                dataMapperKey="dialogProfilesTableData"
                resource={ResourceName.DIALOG_PROFILES}
                table={table}
                searchForm={searchForm}
                actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
            />
        </PageLayout>
    );
};
